export var Join;
(function (Join) {
    let Type;
    (function (Type) {
        Type["Left"] = "LEFT";
        Type["Inner"] = "INNER";
    })(Type = Join.Type || (Join.Type = {}));
    function left(viewName, on, alias) {
        return { viewName, on, alias: alias || viewName, type: "LEFT" };
    }
    Join.left = left;
    function inner(viewName, on, alias) {
        return { viewName, on, alias: alias || viewName, type: "INNER" };
    }
    Join.inner = inner;
})(Join || (Join = {}));
